import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {};
__decorate([Prop({
  default: ''
})], default_1.prototype, "content", void 0);
__decorate([Prop({
  default: 'right'
})], default_1.prototype, "placement", void 0);
default_1 = __decorate([Component({
  name: 'HelpText'
})], default_1);
export default default_1;